import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Modal from '../../../Components/UI/Modal/Modal';
import { deletOfferArtisanAction } from '../../../Store/Actions/actionOffer';
import { useI18n } from '../../../i18n/I18nProvider';

const DeleteOfferArtisan = ({ show, close, demand, loading, deleteOffer }) => {
  const { t } = useI18n();
  const [submitting, setSubmitting] = useState(false);

  const closeSafely = () => {
    if (!submitting) close?.();
  };

  const remove = async () => {
    if (!demand || submitting) return;
    setSubmitting(true);
    const success = await deleteOffer(demand);
    setSubmitting(false);
    if (success) closeSafely();
  };

  return (
    <Modal opened={show} close={closeSafely}>
      <Header>
        <div>
          <Eyebrow>{t('withdraw.eyebrow')}</Eyebrow>
          <Title>{t('withdraw.title')}</Title>
        </div>
        <CloseButton type="button" aria-label={t('common.close')} onClick={closeSafely}>×</CloseButton>
      </Header>

      <Warning>
        <strong>{t('withdraw.warning')}</strong>
        <p>{t('withdraw.detail', { project: demand?.description || t('withdraw.projectDefault') })}</p>
      </Warning>

      <Actions>
        <SecondaryButton type="button" onClick={closeSafely} disabled={submitting || loading}>{t('withdraw.keep')}</SecondaryButton>
        <DangerButton type="button" onClick={remove} disabled={submitting || loading}>
          {submitting ? t('withdraw.withdrawing') : t('withdraw.confirm')}
        </DangerButton>
      </Actions>
    </Modal>
  );
};

const Header = styled.header`display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; margin-bottom: 1.2rem;`;
const Eyebrow = styled.div`margin-bottom: 0.35rem; color: #a23a31; font-size: 0.76rem; font-weight: 900; letter-spacing: 0.12em; text-transform: uppercase;`;
const Title = styled.h2`margin: 0; color: #111111; font-size: clamp(1.3rem, 4vw, 1.85rem);`;
const CloseButton = styled.button`width: 2.5rem; height: 2.5rem; flex: 0 0 auto; border: 0; border-radius: 50%; background: #f1ece5; color: #111111; font: inherit; font-size: 1.6rem; cursor: pointer;`;
const Warning = styled.section`
  padding: 1rem; border: 1px solid #ecd1cf; border-radius: 0.9rem; background: #fff7f6; color: #6e2d28;
  strong { display: block; margin-bottom: 0.45rem; }
  p { margin: 0; line-height: 1.6; }
`;
const Actions = styled.div`display: flex; justify-content: flex-end; gap: 0.7rem; margin-top: 1.25rem; @media (max-width: 560px) { flex-direction: column-reverse; }`;
const BaseButton = styled.button`min-height: 2.8rem; padding: 0.72rem 1.05rem; border-radius: 999px; font: inherit; font-weight: 800; cursor: pointer; &:disabled { opacity: 0.55; cursor: wait; }`;
const DangerButton = styled(BaseButton)`border: 1px solid #aa3b32; background: #b64036; color: #fff;`;
const SecondaryButton = styled(BaseButton)`border: 1px solid #e7dfd2; background: #fff; color: #111111;`;

const mapStateToProps = ({ demands }) => ({ loading: demands?.loading });
const mapDispatchToProps = (dispatch) => ({ deleteOffer: (demand) => dispatch(deletOfferArtisanAction(demand)) });

export default connect(mapStateToProps, mapDispatchToProps)(DeleteOfferArtisan);
